import { makeStyles } from 'tss-react/mui';
import { ParticipantList } from './participant-list';
import { MainParticipant } from './main-participant';


const useStyles = makeStyles()(() => {
  return {
    container: {
      position: 'relative',
      height: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr 0px',
      gridTemplateRows: '100%'
    },
  };
});
// TODO: this should be used instead of what's in the pages dir

export function Room() {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.container)}>
      <MainParticipant />
      <ParticipantList />
    </div>
  );
}
